import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import TrainingProgressCreateEditForm from './Components/TrainingProgressCreateEditForm';
import TrainingProgressApi from './TrainingProgressApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: TrainingProgressCreateEditForm,
                getCreate: TrainingProgressApi.create,
                getClone: TrainingProgressApi.getOne,
                defaults: {},
                successMessage: "TrainingProgress Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}